import _ from 'lodash';

import { getRightsByIndexName } from '../helpers/accessRights';

export default {
  data() {
    return {
      entities: null,
      emptySearch: false,
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      choosenEntities: [],
      publishingPermissionsIds: [101],
      searchPermissionsIds: [230],
      thumbnailsPermissionsIds: [99],
      duplicatesPermissionsIds: [217],
      ...getRightsByIndexName(this.$options.name),
    };
  },

  computed: {
    allowPublishing() {
      return this.$_allowDetecting(this.publishingPermissionsIds, this.userPermissions);
    },
    allowSearchAdministration() {
      return this.$_allowDetecting(this.searchPermissionsIds, this.userPermissions);
    },
    allowRegenerateThumbs() {
      return this.$_allowDetecting(this.thumbnailsPermissionsIds, this.userPermissions);
    },
    allowManageDuplicates() {
      return this.$_allowDetecting(this.duplicatesPermissionsIds, this.userPermissions);
    },
  },

  watch: {
    choosenEntities: {
      handler() {
        const entitiesOnPage = this.entities.length;
        if (this.choosenEntities.length === entitiesOnPage && !this.$refs.allEntities.checked) {
          this.$refs.allEntities.checked = true;
          return;
        }
        if (this.choosenEntities.length < entitiesOnPage && this.$refs.allEntities.checked) {
          this.$refs.allEntities.checked = false;
        }
      },
      deep: true,
    },
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getSource();
    }, 400),
    offset() {
      this.getSource();
    },
    emptySearch() {
      this.getSource();
    },
  },

  mounted() {
    this.getSource();
  },

  methods: {
    $_selectAllEntities(event) {
      if (event.target.checked) {
        this.choosenEntities = this.entities.map(item => item.id);
      } else {
        this.choosenEntities = [];
      }
    },
    $_changePublishedBtns(val) {
      for (let i = 0; i < this.choosenEntities.length; i += 1) {
        const id = this.choosenEntities[i];
        _.find(this.entities, item => item.id === id).published = val;
      }
    },
    $_changePublished(published, name, id) {
      const { namespace } = this.$store.state.contentTypes.list[name];
      const $btnLoader = $(this.$refs[`publishBtnLoader_${id}`]);
      $btnLoader.show();
      if (published) {
        this.$_unpublish(namespace, id)
          .then(() => {
            $btnLoader.hide();
            _.find(this.entities, item => item.id === id).published = false;
          })
          .catch((error) => {
            $btnLoader.hide();
            console.error('Unpublish error: ', error);
          });
      } else {
        this.$_publish(namespace, id)
          .then(() => {
            $btnLoader.hide();
            _.find(this.entities, item => item.id === id).published = true;
            this.$store.commit('notifications/setSuccessNotification', 'Success!');
          })
          .catch((error) => {
            $btnLoader.hide();
            this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in changing publish status' });
            console.error('Publish error: ', error);
          });
      }
    },
    $_publish(namespace, id) {
      const { prefix } = this.$config.app_api;
      return this.$apiHttp.post(`${prefix}content-types/publish?namespace=${namespace}&ids=${id}`);
    },
    $_unpublish(namespace, id) {
      const { prefix } = this.$config.app_api;
      return this.$apiHttp.post(`${prefix}content-types/unpublish?namespace=${namespace}&ids=${id}`);
    },
    $_sendPicks(e, id, namespace) {
      const $btnLoader = $(this.$refs[`pickBtnLoader_${id}`]);
      $btnLoader.show();
      const boxValue = Number(e.target.attributes.value.nodeValue);
      this.$_saveRequest(boxValue, e.target.checked, namespace)
        .then(() => {
          $btnLoader.hide();
        }, (error) => {
          $btnLoader.hide();
          console.error('Error in creating request', error);
          this.$_errorSave(error);
        });
    },
    $_saveRequest(boxValue, isChecked, namespace) {
      const postFormData = new FormData();
      postFormData.append('alias', namespace);
      postFormData.append('id', boxValue);
      if (isChecked) {
        return this.$apiHttp.post(`${this.$config.app_api.prefix}editors-picks/include`, postFormData);
      }
      return this.$apiHttp.post(`${this.$config.app_api.prefix}editors-picks/exclude`, postFormData);
    },
    $_regThumb(entity, contentTypeName, entityName) {
      const entityTitle = entity.title ? entity.title : entity.name;
      const $btnRegThumbLoader = $(this.$refs[`_regThumbBtnLoader_${entity.id}`]);
      $btnRegThumbLoader.show();
      // eslint-disable-next-line max-len
      this.$apiHttp.post(`${this.$config.app_api.prefix}content-types/${contentTypeName}/regenerate-thumbs/${entity.id}`)
        .then(() => {
          console.log(`Thumb for ${entityName} ${entityTitle} with ID = ${entity.id} was regenerated`);
          $btnRegThumbLoader.hide();
          this.$store.commit('notifications/setSuccessNotification', 'Thumb regenerated');
        }).catch((error) => {
          $btnRegThumbLoader.hide();
          this.$store.dispatch(
            'notifications/setHttpError', { error, text: `Error in reg. thumb "${entityTitle}" ${entityName}` },
          );
          console.error(`Error in ${entityName} reg. thumb request`, error);
        });
    },
    $_deleteEntity(entity, endpoint, entityName) {
      const entityTitle = entity.title ? entity.title : entity.name;
      if (window.confirm(`Do you really want to delete ${entityName} ${entityTitle} with id = ${entity.id}?`)) {
        const $btnDeleteLoader = $(this.$refs[`deleteBtnLoader_${entity.id}`]);
        $btnDeleteLoader.show();
        this.$apiHttp.delete(this.$config.app_api.prefix + endpoint + entity.id).then(() => {
          console.log(`${entityName} ${entityTitle} with ID = ${entity.id} has deleted`);
          $btnDeleteLoader.hide();
          this.getSource();
          this.$store.commit('notifications/setSuccessNotification', 'Deleted');
        }).catch((error) => {
          $btnDeleteLoader.hide();
          this.$store.dispatch(
            'notifications/setHttpError', { error, text: `Error in deleting "${entityTitle}" ${entityName}` },
          );
          console.error(`Error in ${entityName} delete request`, error);
        });
      }
    },
    $_addToIndexAll(entityName) {
      const $btnLoader = $('.add-to-index-all .btn-loader');
      $btnLoader.show();
      this.$apiHttp.post(`${this.$config.app_api.prefix}search/documents/${entityName}`)
        .then(() => {
          this.$store.commit('notifications/setSuccessNotification', 'Indeces updated');
          $btnLoader.hide();
        })
        .catch((error) => {
          $btnLoader.hide();
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in updating index request' });
          console.error(`Error in indexing ${entityName} request`, error);
        });
    },
    $_addToIndexSingle(entityName, entityId) {
      const $btnLoader = $(`table.entities tr[data-id="${entityId}"] .add-to-index-single .btn-loader`);
      $btnLoader.show();
      this.$apiHttp.post(`${this.$config.app_api.prefix}search/documents/${entityName}/${entityId}`)
        .then(() => {
          this.$store.commit('notifications/setSuccessNotification', 'Index updated');
          $btnLoader.hide();
        })
        .catch((error) => {
          $btnLoader.hide();
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in updating index request' });
          console.error(`Error in indexing ${entityName} request`, error);
        });
    },
    $_regenerateThumbs(entityName, entityTitle) {
      if (window.confirm(`Are you sure you want to start regeneration thumbnail process for ${entityTitle}?`)) {
        const $btnLoader = $('.regenerate-thumbs .btn-loader');
        $btnLoader.show();
        this.$apiHttp.post(`${this.$config.app_api.prefix}content-types/${entityName}/regenerate-thumbs`)
          .then(() => {
            this.$store.commit('notifications/setSuccessNotification', 'Thumbnails regenerating has started. ');
            $btnLoader.hide();
          })
          .catch((error) => {
            $btnLoader.hide();
            this.$store.dispatch(
              'notifications/setHttpError', { error, text: 'Error in regenerating thumbnails request' },
            );
            console.error(`Error in indexing ${entityName} request`, error);
          });
      }
    },
    $_changePage(offset) {
      this.offset = offset;
    },
    $_errorCallback(error) {
      if (this.$refs.spinner) this.$refs.spinner.hide();
      this.entities = [];
      this.total = 0;
      this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting list request' });
      console.error(error);
    },
    $_allowedGlobalCreate() {
      return !!this.userPermissions.find(permission => permission.id === this.permissionTypes.CREATE_GLOBALLY);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ListPageMixin.js